module.exports = __webpack_public_path__ + "static/media/new-auction-requirement.4043c7dd.svg";